<script setup lang="ts">
import { computed } from 'vue';
import { loadingService } from '@/services/LoadingService';
const visible = computed(() => loadingService.active.value > 0);
</script>

<template>
  <div v-if="visible" class="kl-loading-bar" role="progressbar" aria-label="Bezig met laden"></div>
</template>
